import { API_BASE_URL } from "../config";

export const getOrFetchToken = async () => {
  let token;

  if (!token) {
    const res = await fetch(`${API_BASE_URL}/api/register-device`, {
      method: "POST",
    });

    if (!res.ok) throw new Error("Failed to get device token");

    const data = await res.json();
    token = data.token;
    localStorage.setItem("device_token", token);
  }

  return token;
};